import { FC } from 'react'

import useComponentColor from 'src/hooks/useComponentColor'
import useGetCurrentProductName from 'src/hooks/useGetCurrentProductName'
import usePageSubProductTitle from 'src/hooks/usePageSubProductTitle'
import useSelectedDashboardStore from 'src/stores/useSelectedDashboardStore'
import { getProductNameFn } from 'src/utils/productUtils'
import PageHeaderTitle from '../../features/PageHeader/PageHeaderTitle'

const CURATION_DASHBOARD_ID = '67c0362a18b830c2605adeb5'

interface PageHeaderProductTitleProps {
  subProductTitle?: string
}

const PageHeaderProductTitle: FC<PageHeaderProductTitleProps> = () => {
  const element = useGetCurrentProductName()
  const componentColor = useComponentColor()

  const subProductName = usePageSubProductTitle()

  const selectedDashboard = useSelectedDashboardStore(state => state.selectedDashboard)

  if (!element) {
    return null
  }

  return (
    <PageHeaderTitle
      title={getProductNameFn(`${element.parentName} ${element.name}`)}
      subTitle={subProductName}
      dataPendo={
        selectedDashboard?.id === CURATION_DASHBOARD_ID
          ? 'dashboard-curation-monitoring-header'
          : undefined
      }
      componentColor={componentColor}
    />
  )
}

export default PageHeaderProductTitle
